export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6848.454fa7ac.jpg";